export default "__VITE_ASSET__d5a791b2__"